import '@/app/app.css';
import './sample-page.css';

import '@/app/app';
import '@/layouts/main/main';

import { SliderProducts } from '@/features/slider-products/slider-products';
import { ProductBlock } from '@/features/product-block/product-block';

window.app.ProductBlock = ProductBlock;
window.app.SliderProducts = SliderProducts;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));

	const tables = document.querySelectorAll('table');
	tables.forEach(table => {
		const wrapper = document.createElement('div');

		wrapper.classList.add('table-wrapper');

		table.parentNode.insertBefore(wrapper, table);
		wrapper.appendChild(table);
	});
});
